import type { ChecklistItemStatus } from '../../../../../components/checklist';
import { PRICE_LIST_SOURCES, usePaginatedAllPriceLists } from '../../../../price-lists';

// Complete once the store has any custom price list. Setup doesn't track a specific one — editing is
// delegated to the price-list page — so existence is the whole signal.
export function useChecklistStatus(): ChecklistItemStatus | undefined {
  const { data, isLoading } = usePaginatedAllPriceLists([PRICE_LIST_SOURCES.CUSTOM]);
  if (isLoading) {
    return undefined;
  }
  return data.length > 0 ? 'complete' : 'pending';
}
